module.exports = [
	{
		"path": "graphics",
		"name": "Graphics"
	},
	{
		"path": "print-templates",
		"name": "Print"
	},
	{
		"path": "epublishing",
		"name": "ePublishing"
	},
	{
		"path": "web-elements",
		"name": "Web Elements"
	},
	{
		"path": "add-ons",
		"name": "Add-ons"
	},
	{
		"path": "vectors",
		"name": "Vectors"
	},
	{
		"path": "presentation-templates",
		"name": "Presentations"
	},
	{
		"path": "infographics",
		"name": "Infographics"
	},
	{
		"path": "icons",
		"name": "Icons"
	},
	{
		"path": "fonts",
		"name": "Fonts"
	},
	{
		"path": "logo-templates",
		"name": "Logos"
	},
	{
		"path": "game-assets",
		"name": "Game Assets"
	},
	{
		"path": "isolated-objects",
		"name": "Isolated Objects"
	},
	{
		"path": "t-shirts",
		"name": "T-Shirts"
	},
	{
		"path": "textures",
		"name": "Textures"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/categories/graphicriver.json
// module id = 221
// module chunks = 1 2